<div class="alert-notification alert-notification__{{type}}">
  <div class="icon"><i class="bi {{iconClass}}"></i></div>
  <div class="content">{{ text | translate }}</div>
  <ng-content></ng-content>
</div>
